const tabs = {listtab: 'tablist', registertab: 'tabregister', listbondtab: 'tabbondlist', registerbondtab: 'tabbondregister'};

export const userTabs = {
    tabs,
};
